import { Accordion, AccordionGroup, Heading, Paragraph, Section } from '@alto-avios/alto-ui'
import { ContentfulAccordionSection as ContentfulAccordionSectionProps } from '@reward-platform/contentful'
import { useTagManagerContext } from '~/context/analytics'
import { RichText } from './ContentfulRichText'
import styles from './ContentfulAccordionSection.module.scss'

const ContentfulAccordionSection = ({
  title,
  description,
  allowMultipleExpanded,
  items,
}: ContentfulAccordionSectionProps) => {
  const { pushEventToDataLayer } = useTagManagerContext()

  return (
    <Section
      containerMaxWidth="page"
      paddingX="default"
      paddingY="default"
      flexDirection="row"
      justifyContent="center"
      alignItems="start"
    >
      <Section.Container alignItems="center" className={styles.sectionContainer}>
        <AccordionGroup
          title={
            <Heading as="h2" size="md" textAlign="center">
              {title}
            </Heading>
          }
          description={<Paragraph textAlign="center">{description}</Paragraph>}
          allowsMultipleExpanded={allowMultipleExpanded}
        >
          {items?.map((item) => {
            if (!item.accordionButton || !item.accordionPanel) {
              return null
            }

            const faqTitle = item.accordionButton

            return (
              <Accordion
                key={faqTitle}
                title={faqTitle}
                onExpandedChange={(isExpanded) => {
                  if (isExpanded) {
                    pushEventToDataLayer('ctaEvent', {
                      nav_element: 'faq',
                      nav_type: 'expand',
                      nav_action: faqTitle,
                    })
                  }
                }}
              >
                <RichText document={item.accordionPanel} openLinksInNewTab />
              </Accordion>
            )
          })}
        </AccordionGroup>
      </Section.Container>
    </Section>
  )
}

export default ContentfulAccordionSection
